<div class="overflow-auto w-full h-full pb-20 bg-slate-50/50 font-prompt relative select-none animate-fade-in">

  <!------------------------------ Curved Header with Premium Gradient ------------------------------>
  <div
    class="absolute top-0 left-0 right-0 h-[200px] bg-gradient-to-r from-(--main-color) to-(--soft-color) rounded-b-[2.5rem] shadow-md z-0 transition-all duration-300">
  </div>

  <!---------------------------------------- Header Navigation & Title ---------------------------------->
  <div class="relative z-10 flex-none px-4 pt-4 pb-2">
    <div class="flex items-center justify-between">
      <button (click)="goBack()"
        class="w-10 h-10 bg-white/95 backdrop-blur-sm rounded-full shadow-md flex items-center justify-center text-slate-700 hover:text-amber-500 active:scale-95 transition-all outline-none">
        <img src="icons/arrow_back_black.svg" class="w-5 h-5" />
      </button>
      <h1 class="text-lg font-extrabold text-slate-800 tracking-wide">
        {{ currentLang === "TH" ? "ใบเสร็จรับเงิน" : "Payment Receipt" }}
      </h1>
      <div class="w-10"></div>
    </div>
  </div>

  <!---------------------------------------- Top Icon Badge Graphic ------------------------------>
  <div class="relative flex flex-col items-center pb-3 pt-1 z-10 flex-none">
    <div class="p-2 bg-white rounded-full shadow-lg shadow-gray-200/50 flex items-center justify-center">
      <div class="w-[64px] h-[64px] p-3.5 bg-amber-50 shadow-inner rounded-full flex items-center justify-center">
        <img src="icons/receipt_long_orange.svg" class="w-8 h-8" />
      </div>
    </div>
  </div>

  <!---------------------------------------- PRINTABLE RECEIPT ---------------------------------->
  <div class="relative z-10 px-4 mt-2">
    <div id="printable-receipt" class="max-w-sm mx-auto relative">

      <!-- Thermal Receipt Slip Paper Container -->
      <div #receiptRef class="thermal-receipt py-8 px-6 rounded-[2px] receipt-bg-white relative">

        <!-- Top Zigzag border (SVG) -->
        <div class="zigzag-top">
          <svg class="w-full h-full text-white fill-current block" viewBox="0 0 100 10" preserveAspectRatio="none">
            <polygon
              points="0,10 2.5,0 5,10 7.5,0 10,10 12.5,0 15,10 17.5,0 20,10 22.5,0 25,10 27.5,0 30,10 32.5,0 35,10 37.5,0 40,10 42.5,0 45,10 47.5,0 50,10 52.5,0 55,10 57.5,0 60,10 62.5,0 65,10 67.5,0 70,10 72.5,0 75,10 77.5,0 80,10 82.5,0 85,10 87.5,0 90,10 92.5,0 95,10 97.5,0 100,10" />
          </svg>
        </div>

        <!-- Receipt Header: Company Info -->
        <div class="text-center pb-2">
          <h2 class="text-[17px] font-extrabold tracking-widest receipt-text-dark receipt-mono">CITY PARKING</h2>
          <p class="text-[9.5px] receipt-text-gray-500 leading-relaxed mt-1 font-medium max-w-[90%] mx-auto">
            45/4 หมู่ 5 ต.บางเมือง อ.เมืองสมุทรปราการ จ.สมุทรปราการ 10270<br />
            {{ currentLang === "TH" ? "โทรศัพท์" : "Tel." }}: 02-096-2255
          </p>

          <div class="receipt-dashed-line"></div>

          <p class="text-[11px] font-bold tracking-wider receipt-text-dark receipt-mono mt-1">
            {{ currentLang === "TH" ? "ใบเสร็จรับเงิน" : "RECEIPT" }}
          </p>
        </div>

        <div class="receipt-dashed-line"></div>

        <!-- Receipt Meta Info -->
        <div class="space-y-2 py-1">
          <div class="flex justify-between items-center text-[11.5px] receipt-text-dark">
            <span class="font-medium receipt-text-gray-500">{{ currentLang === "TH" ? "เลขที่ใบเสร็จ" : "Receipt No."
              }}</span>
            <span class="font-bold receipt-mono receipt-text-dark select-all">{{ selectedPayment?.receiptId || '-'
              }}</span>
          </div>

          <div class="flex justify-between items-center text-[11.5px] receipt-text-dark">
            <span class="font-medium receipt-text-gray-500">{{ currentLang === "TH" ? "วันที่รับชำระ" : "Payment Date"
              }}</span>
            <span class="font-bold receipt-mono receipt-text-dark">
              {{ selectedPayment?.paidDate ? (selectedPayment?.paidDate | date : "dd/MM/yyyy HH:mm") : '-' }}
            </span>
          </div>

          <div class="flex justify-between items-center text-[11.5px] receipt-text-dark">
            <span class="font-medium receipt-text-gray-500">{{ currentLang === "TH" ? "ประเภทการชำระ" : "Payment Method"
              }}</span>
            <span class="font-bold receipt-text-dark">{{ selectedPayment?.feeTypeName || '-' }}</span>
          </div>

          <div class="flex justify-between items-start text-[11.5px] receipt-text-dark">
            <span class="font-medium receipt-text-gray-500">{{ currentLang === "TH" ? "ชื่อผู้ใช้" : "Customer"
              }}</span>
            <span class="font-bold receipt-text-dark text-right max-w-[60%] break-words">{{ selectedPayment?.userName ||
              '-' }}</span>
          </div>
        </div>

        <div class="receipt-dashed-line"></div>

        <!-- Vehicle Info -->
        <div class="space-y-2 py-1">
          <div class="flex justify-between items-start text-[11.5px] receipt-text-dark">
            <span class="font-medium receipt-text-gray-500">{{ currentLang === "TH" ? "ทะเบียนรถ" : "License Plate"
              }}</span>
            <span class="font-bold receipt-text-dark text-right max-w-[60%] break-words">{{ selectedPayment?.lincense ||
              '-' }}</span>
          </div>

          <div class="flex justify-between items-center text-[11.5px] receipt-text-dark">
            <span class="font-medium receipt-text-gray-500">{{ currentLang === "TH" ? "ประเภทรถ" : "Vehicle Type"
              }}</span>
            <span class="font-bold receipt-text-dark">{{ selectedPayment?.vehicleTypeName || '-' }}</span>
          </div>

          <div *ngIf="selectedPayment?.siteName"
            class="flex justify-between items-start text-[11.5px] receipt-text-dark">
            <span class="font-medium receipt-text-gray-500">{{ currentLang === "TH" ? "สถานที่จอด" : "Location"
              }}</span>
            <span class="font-bold receipt-text-dark text-right max-w-[60%] break-words">{{ selectedPayment?.siteName
              }}</span>
          </div>
        </div>

        <div class="receipt-dashed-line"></div>

        <!-- Billing Lines (Items) -->
        <div class="space-y-2 py-1">
          <div class="flex justify-between items-start text-[11.5px] receipt-text-dark">
            <div class="flex-1 pr-2">
              <span class="font-medium receipt-text-gray-500 block">{{ currentLang === "TH" ? "รายการ" : "Description"
                }}</span>
              <span class="font-bold receipt-text-dark block mt-0.5">{{ selectedPayment?.feeName || '-' }}</span>
            </div>
            <span class="font-bold receipt-mono receipt-text-dark text-right whitespace-nowrap pt-3">
              {{ ((selectedPayment?.fee || 0) + (selectedPayment?.vat || 0)) | number : "1.2-2" }}
            </span>
          </div>

          <div *ngIf="selectedPayment?.discount"
            class="flex justify-between items-center text-[11.5px] receipt-text-rose-500">
            <span class="font-medium">{{ currentLang === "TH" ? "ส่วนลด" : "Discount" }}</span>
            <span class="font-bold receipt-mono">
              -{{ (selectedPayment?.discount ?? 0) | number : "1.2-2" }}
            </span>
          </div>
        </div>

        <div class="receipt-double-dashed-line"></div>

        <!-- Total Section -->
        <div class="py-1">
          <div class="flex justify-between items-center">
            <span class="text-[12px] font-extrabold uppercase tracking-widest receipt-text-dark">
              {{ currentLang === "TH" ? "รวมทั้งสิ้น" : "Total" }}
            </span>
            <div class="flex items-baseline gap-1 receipt-text-dark">
              <span class="text-[20px] font-black receipt-mono tracking-tight text-amber-600">
                {{ selectedPayment?.total | number : "1.2-2" }}
              </span>
              <span class="text-[11px] font-bold">{{ currentLang === "TH" ? "บาท" : "Baht" }}</span>
            </div>
          </div>
        </div>

        <div class="receipt-dashed-line"></div>

        <!-- Barcode Graphic Number -->
        <div class="py-2 text-center" *ngIf="selectedPayment?.receiptId">
          <div
            class="text-[9.5px] font-semibold receipt-text-dark tracking-[0.25em] mt-0.5 receipt-mono text-center select-all">
            *{{ selectedPayment?.receiptId }}*
          </div>
        </div>

        <div class="receipt-dashed-line"></div>

        <!-- Thank You Message -->
        <div class="text-center pt-1 pb-1">
          <p class="text-[10px] receipt-text-gray-500 font-bold uppercase tracking-wider receipt-mono">
            {{ currentLang === "TH" ? "ขอบคุณที่ใช้บริการ" : "Thank You" }}
          </p>
          <p class="text-[9px] receipt-text-gray-400 mt-0.5">
            PSS GROUP (THAILAND) Co., Ltd.
          </p>
        </div>

        <!-- Bottom Zigzag border (SVG) -->
        <div class="zigzag-bottom">
          <svg class="w-full h-full text-white fill-current block" viewBox="0 0 100 10" preserveAspectRatio="none">
            <polygon
              points="0,0 2.5,10 5,0 7.5,10 10,0 12.5,10 15,0 17.5,10 20,0 22.5,10 25,0 27.5,10 30,0 32.5,10 35,0 37.5,10 40,0 42.5,10 45,0 47.5,10 50,0 52.5,10 55,0 57.5,10 60,0 62.5,10 65,0 67.5,10 70,0 72.5,10 75,0 77.5,10 80,0 82.5,10 85,0 87.5,10 90,0 92.5,10 95,0 97.5,10 100,0" />
          </svg>
        </div>

      </div>

    </div>

    <!-- Action Buttons (Non-printable) -->
    <div class="max-w-sm mx-auto mt-6 space-y-2.5 no-print">
      <button (click)="downloadReceiptImage()"
        class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-slate-800 text-xs font-bold rounded-xl py-3 shadow-[0_4px_12px_rgba(245,158,11,0.25)] transition-all duration-200 active:scale-95 outline-none flex items-center justify-center gap-2">
        <img src="icons/content_copy_slate.svg" class="w-4 h-4 invert" />
        <span>{{ currentLang === "TH" ? "บันทึกใบเสร็จเป็นรูปภาพ" : "Save Receipt Image" }}</span>
      </button>

      <button (click)="goBack()"
        class="w-full bg-white hover:bg-slate-50 text-slate-600 text-xs font-bold rounded-xl py-2.5 border border-slate-200 transition-all duration-200 active:scale-95 outline-none">
        {{ currentLang === "TH" ? "ย้อนกลับ" : "Go Back" }}
      </button>
    </div>
  </div>

</div>